
    import '/home/ec2-user/Youlify-Design/components/breadcrumb/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["breadcrumb-demo-basic","breadcrumb-demo-withicon","breadcrumb-demo-withparams","breadcrumb-demo-separator","breadcrumb-demo-overlay","breadcrumb-demo-separator-component","breadcrumb-demo-debug-routes","breadcrumb-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/breadcrumb/index.zh-CN.md?type=demo')
};